import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import logo from '../../assets/images/logo.svg';
import menuIcon from '../../assets/images/manue.svg';
import UnifiedMenu from '../dashboard/UnifiedMenu';
import DashboardSideBar from '../dashboard/DashboardSIdeBar';

const OrganizationLayout = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const toggleMobileMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);
  return (
    <div className='flex lg:flex-row flex-col'>
      <div className={`lg:w-[240px] ${isMobileMenuOpen === false ? "flex" : "block"} justify-between p-4 w-full lg:p-0`}>

        {isMobileMenuOpen === false ?
          <img
            src={logo}
            alt="logo"
            className="w-8 h-8 md:w-12 md:h-12 lg:w-auto lg:h-auto lg:hidden"
          /> : ""}


        <div className='hidden lg:flex'>
          <DashboardSideBar />
        </div>

        {isMobileMenuOpen === false ? <img
          src={menuIcon}
          alt="menu"
          className="w-6 h-auto lg:hidden cursor-pointer"
          onClick={toggleMobileMenu}
        /> : ""}


        {isMobileMenuOpen && (
          <div className='flex lg:hidden bg_header'>
            <UnifiedMenu setIsMobileMenuOpen={setIsMobileMenuOpen} />
          </div>
        )}
      </div>


      <div className='flex-1'>
        <Outlet />
      </div>
    </div>
  );
};

export default OrganizationLayout;
